import styled, { css } from 'styled-components';
import { AiOutlineMail } from 'react-icons/ai';
import { MdOutlineCloudDownload } from 'react-icons/md';
import { RiInformationLine, RiInformationFill} from 'react-icons/ri';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  justify-content: space-between;
  max-width: 80%;

  & + div {
    margin-top: 16px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: baseline;
    max-width: none;
  }
`;

export const WrapFileDetails = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const TitleFileLabel = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: bold;
  font-size: 12px;
  line-height: 19px;
  color: #0B29FB;
`

export const TitleFile = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  line-height: 25px;
  color: #828282;

  @media (max-width: 600px) {
    overflow-wrap: break-word;
  }
`

export const CheckBoxContainer = styled.div`
  padding-left: 19px;
`;

export const DetailsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 60%;
  padding: 9px 19px 16px 0;
  border-right: 1px dashed rgba(0, 0, 0, 0.1);

  ${({ active }) => active && css`
    background: #F2EFEF;
    border-radius: 10px 0px 0px 10px;
  `}

  @media (max-width: 600px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
    flex-direction: column;
    align-items: baseline;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 40%;
  padding: 9px 19px 16px 19px;

  @media (max-width: 600px) {
    width: 100%;
    justify-content: center;
  }
`;

export const ActionsWrap = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  align-content: center;
`;

export const InformationIconActive = styled(RiInformationFill)`
  cursor: pointer;
`;

export const InformationIconInActive = styled(RiInformationLine)`
  cursor: pointer;
`;

export const DownLoadIcon = styled(MdOutlineCloudDownload)`
  cursor: pointer;
`;

export const MailIcon = styled(AiOutlineMail)`
  cursor: pointer;
`;

